import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { useLocalizedHref } from "@/libraries/web-framework";

export type AgileUpNextLinkProps = {
    name: string;
    urlSlug: string;
};

// NOTE: Extracted from "@/libraries/wpl/foundations/src/icons/basic/arrow-right-no-circle"
// because it does not support 'currentcolor'.
// see: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#currentcolor_keyword
const ArrowRightNoCircle = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 8" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.40796 0L6.32831 1.2021L8.07854 3.1497H0.763182C0.341906 3.1497 0 3.53038 0 3.99943C0 4.46849 0.341906 4.84917 0.763182 4.84917H8.07854L6.32831 6.7979L7.40796 8L11 3.99943L7.40796 0Z"
            fill="currentcolor"
        />
    </svg>
);

const AgileUpNextLinkContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
});

const AgileUpNextLinkTextStyle = css({
    display: "block",
    margin: "-5px 30px 0 0"
});

const AgileUpNextLinkArrowStyle = css({
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "flex-end",
    "flexWrap": "nowrap",
    "gap": 10,
    "color": "#0052cc",
    "fontSize": "1.25rem",
    "textAlign": "right",
    "lineHeight": "1",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".link-arrow-up-next": {
        width: 18,
        transform: "translateX(0px)",
        transition: "transform 0.2s ease-in-out",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
    },
    "&:hover": {
        "color": "#0065ff",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ".link-arrow-up-next": {
            transform: "translateX(3px)"
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "ul": {
        marginBlockStart: "auto"
    },
    [media.below.md]: {
        fontSize: "1rem"
    }
});

export const AgileUpNextLink = ({ name, urlSlug }: AgileUpNextLinkProps) => {
    const intl = useIntl();

    const linkText = intl.formatMessage({
        id: "Agile.main.up-next-link",
        defaultMessage: "Up Next"
    });
    return (
        <div
            css={AgileUpNextLinkContainerStyle}
            data-testid="agile-up-next-link"
        >
            <div css={AgileUpNextLinkTextStyle}>{linkText}</div>
            <div>
                <a
                    css={AgileUpNextLinkArrowStyle}
                    data-event="clicked"
                    data-event-component="linkButton"
                    data-event-container="agileUpNextLink"
                    data-product-key="jiraSoftware"
                    href={useLocalizedHref(urlSlug)}
                >
                    <span>{name}</span>
                    <span className="link-arrow-up-next">
                        <ArrowRightNoCircle />
                    </span>
                </a>
            </div>
        </div>
    );
};
